module.exports = {"230902031":"兴安街道","230902032":"兴富街道","230902033":"兴和街道","230902034":"兴盛街道","230902035":"欣源街道","230902036":"北山街道","230902037":"兴华街道","230902038":"金沙街道","230902100":"红旗镇","230902200":"长兴乡","230902400":"七台河经济开发区管理委员会","230902480":"金沙农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230902.json
// module id = 866
// module chunks = 0